<template>
  <!-- DATETIME -->
  <div class="event-datetime-wrapper  is-block" v-if="event">

    <div style="position: relative; padding-top: 2px">

        <span class="icon has-text-grey-dark is-medium" style="position: absolute; left: 12px; top: 0;">
          <i class="mdi mdi-ticket-confirmation mdi-24px"></i>
        </span>


      <!-- MULTIIPLE SHOWTIMES -->
      <div class="is-rail has-gradient-mask py-0 is-size-15px" style="margin-left: 52px; width: calc(100vw - 52px)">
        <div
          class="is-white date-card is-borderless"
          style="opacity: 1"
          v-for="(ticket, ind) in event.data.eventTicketInfo.ticketTypes"
          :key="ind"
        >
          <span
            class="is-block has-text-weight-medium"
          >{{ ticket.ticketType  }}</span>
          <span
            class="is-inline-block"
          >{{ parseInt(ticket.ticketPrice).toFixed(2) }} ₺</span>
        </div>

        <div class="is-rail-end-gap"></div>
      </div>
    </div>
  </div>
  <!-- ./DATETIME -->
</template>

<script>
// import { ticketPriceMixin } from "@/mixins/ticket";
export default {
    // mixins: [ticketPriceMixin],
  props: {
    title: {
      type: String,
      default: ""
    },
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedDate: {}
    };
  },
  methods: {
   
  }
};
</script>

<style lang="scss" scoped>

.date-card.is-borderless + .date-card.is-borderless {
  border-left: 1px solid $grey-lighter;
}


.is-rail .date-card {
  position: relative;
  padding: 0 0.75rem;
  display: inline-block;
}
.date-card.is-active {
  border: 1px solid $info !important;
  opacity: 1;
  // padding-right: 1.25rem !important;
}

.is-rail .date-card:first-child {
  padding-left: 0;
  // border-radius: 24px;
}

.is-rail .date-card.has-border {
  border: 1px solid $grey-lighter;
  border-radius: 4px;
}

</style>